<taku-form-dialoge-header
  [pristine]="_myForm.pristine"
  [valid]="_myForm.valid"
  (backClicked)="goBack()"
  (saveClicked)="onSave()"
  (revertClicked)="onRevert()"
  (cancelClicked)="closeModal()"
  (newClicked)="onNew()"
  (deleteClicked)="onDelete()"
  (cloneClicked)="onClone()"
  toolbarTitle="Units of Measure Details"
>
</taku-form-dialoge-header>

<form [formGroup]="_myForm" novalidate *ngIf="active">
  <div class="card card-w-title">
    <div class="grid form-group">
      <div class="col-12">
        <taku-input [formGroup]="_myForm" [fieldName]="'name'" [fieldCaption]="'Measure Desc'"> </taku-input>
      </div>
      <div class="col-12">
        <taku-dropdown
          [formGroup]="_myForm"
          [options]="_enum_stock_type"
          [fieldName]="'type'"
          [fieldCaption]="'Measure Type'"
          appendTo="body"
        ></taku-dropdown>
      </div>
      <div class="col-12">
        <taku-checkbox [formGroup]="_myForm" [fieldName]="'isEnabled'" fieldCaption="Is Active?"> </taku-checkbox>
      </div>
    </div>
  </div>
</form>

<taku-form-footer></taku-form-footer>
